export enum StorageEnum {
    add, 
    update, 
    remove,
    removeAll 
}